import { render } from "./RenewalManagement.vue?vue&type=template&id=cdbb43c0&scoped=true"
import script from "./RenewalManagement.vue?vue&type=script&lang=js"
export * from "./RenewalManagement.vue?vue&type=script&lang=js"

import "./RenewalManagement.vue?vue&type=style&index=0&id=cdbb43c0&scoped=true&lang=scss"

import exportComponent from "D:\\myProgram\\cloud-storage\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cdbb43c0"]])

export default __exports__